import React from "react";
import { useLanguage } from "@/context/LanguageContext";

const LABELS = { pt: "PT", en: "EN", es: "ES" };

export default function LanguageToggle({ variant = "light" }) {
  const { lang, setLang, supported } = useLanguage();
  const isDark = variant === "dark";

  return (
    <div
      data-testid="language-toggle"
      className={`inline-flex items-center gap-0 rounded-sm border px-1 py-1 text-[11px] tracking-[0.28em] ${
        isDark
          ? "glass-dark border-white/20 text-white/85"
          : "glass border-warmBorder text-ocean/80"
      }`}
    >
      {supported.map((code, i) => {
        const active = code === lang;
        return (
          <React.Fragment key={code}>
            <button
              type="button"
              data-testid={`lang-${code}`}
              onClick={() => setLang(code)}
              aria-label={`Switch language to ${LABELS[code]}`}
              aria-pressed={active}
              className={`px-3 py-1 font-medium transition-colors duration-200 ${
                active
                  ? isDark
                    ? "text-white"
                    : "text-terracotta"
                  : isDark
                    ? "hover:text-white"
                    : "hover:text-ocean"
              }`}
            >
              {LABELS[code]}
            </button>
            {i < supported.length - 1 && (
              <span
                aria-hidden
                className={`${isDark ? "text-white/25" : "text-ocean/25"} text-[8px]`}
              >
                •
              </span>
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
}
